const config = require('./AppConfig.json');

// Jwt
export const Jwt_token = config.jwt_token;

export {
	todoRoleTabConfig,
	getTodoRoleConfig,
	getVisibleTodoTabs,
	getDefaultTodoActiveTabId,
	todoRoleStateFilterConfig,
	getTodoRoleStateFilters
} from './TodoRoleConfig';
